import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function PdfSvg() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_21307_77405)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4096 0H22.3774C25.152 0 27.4095 2.2575 27.4095 5.03297V24.9671C27.4095 27.7421 25.152 30.0001 22.3774 30.0001H8.03297C5.2575 30.0001 3 27.7421 3 24.9671V9.40969V8.63766L3.54574 8.09191L11.0914 0.545742L11.6372 0H12.4096ZM21.9547 27.9194C23.7049 27.9194 25.1237 26.5006 25.1237 24.75V5.25C25.1237 3.49934 23.7049 2.08055 21.9547 2.08055H12.4096V6.98584C12.4096 8.44436 11.2265 9.62666 9.7684 9.62666H5.08565V24.75C5.08565 26.5006 6.50444 27.9194 8.25546 27.9194H21.9547ZM8.56792 14.25H10.4177C11.7297 14.25 12.5048 15.0283 12.5047 16.1653C12.5047 17.2848 11.7206 18.0721 10.4177 18.0721H9.35201C9.31668 18.0721 9.29859 18.0896 9.29859 18.1247V19.5675C9.29859 19.9789 9.02607 20.25 8.65578 20.25C8.27731 20.25 8.00473 19.9788 8.00473 19.5675V14.8183C8.00473 14.4775 8.21572 14.25 8.56792 14.25ZM9.35201 16.9611H10.3381C10.884 16.9611 11.21 16.6464 11.21 16.1654C11.21 15.6843 10.884 15.3606 10.3381 15.3606H9.35201C9.31668 15.3606 9.29859 15.378 9.29859 15.4131V16.909C9.29859 16.9436 9.31668 16.9611 9.35201 16.9611ZM15.4617 14.25H14.0577C13.7089 14.25 13.5 14.4795 13.5 14.8233V19.6853C13.5 20.0296 13.7089 20.25 14.0577 20.25H15.4617C16.726 20.25 17.5114 19.844 17.8252 18.8647C17.9382 18.5204 18 18.1059 18 17.25C18 16.3941 17.9381 15.9795 17.8252 15.6353C17.5113 14.656 16.726 14.25 15.4617 14.25ZM16.5959 18.4148C16.4471 18.8911 16.0203 19.0943 15.4268 19.0943H14.8341C14.7991 19.0943 14.7812 19.0766 14.7812 19.0412V15.4588C14.7812 15.4234 14.7991 15.4057 14.8341 15.4057H15.4268C16.0203 15.4057 16.4471 15.609 16.5959 16.0853C16.6569 16.2885 16.7 16.6413 16.7 17.25C16.7 17.8587 16.6569 18.2116 16.5959 18.4148ZM19.5785 14.25H22.7918C23.1913 14.25 23.4546 14.486 23.4547 14.8098C23.4547 15.1245 23.1913 15.3606 22.7918 15.3606H20.4447C20.4056 15.3606 20.3866 15.378 20.3866 15.4131V16.664C20.3866 16.6991 20.4056 16.7166 20.4447 16.7166H22.3152C22.7337 16.7166 22.977 16.9436 22.977 17.2673C22.977 17.5911 22.7337 17.8185 22.3152 17.8185H20.4447C20.4056 17.8185 20.3866 17.836 20.3866 17.8707V19.5675C20.3866 19.9789 20.0842 20.25 19.6757 20.25C19.2572 20.25 18.9547 19.9788 18.9547 19.5675V14.8183C18.9547 14.4775 19.189 14.25 19.5785 14.25Z"
          fill="#5D6266"
        />
      </g>
      <defs>
        <clipPath id="clip0_21307_77405">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

function LargePdfSvg() {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1065_66257)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5462 0.5H29.8365C33.5359 0.5 36.5459 3.51 36.5459 7.21063V33.7895C36.5459 37.4895 33.5359 40.5001 29.8365 40.5001H10.7106C7.01 40.5001 4 37.4895 4 33.7895V13.0462V12.0169L4.72766 11.2892L14.7886 1.22766L15.5163 0.5H16.5462ZM29.2729 37.7259C31.6065 37.7259 33.4983 35.8341 33.4983 33.5V7.5C33.4983 5.16578 31.6065 3.27406 29.2729 3.27406H16.5462V9.81445C16.5462 11.7591 14.9687 13.3355 13.0245 13.3355H6.78087V33.5C6.78087 35.8341 8.67259 37.7259 11.0073 37.7259H29.2729ZM11.4239 19.5H13.8903C15.6396 19.5 16.6731 20.5377 16.673 22.0537C16.673 23.5464 15.6275 24.5961 13.8903 24.5961H12.4694C12.4222 24.5961 12.3981 24.6195 12.3981 24.6663V26.59C12.3981 27.1385 12.0348 27.5 11.541 27.5C11.0364 27.5 10.673 27.1385 10.673 26.59V20.2577C10.673 19.8033 10.9543 19.5 11.4239 19.5ZM12.4694 23.1148H13.7841C14.512 23.1148 14.9467 22.6952 14.9466 22.0538C14.9466 21.4124 14.512 20.9808 13.7841 20.9808H12.4694C12.4222 20.9808 12.3981 21.004 12.3981 21.0508V23.0453C12.3981 23.0915 12.4222 23.1148 12.4694 23.1148ZM20.6157 19.5H18.7436C18.2786 19.5 18 19.806 18 20.2644V26.747C18 27.2061 18.2785 27.5 18.7436 27.5H20.6157C22.3013 27.5 23.3485 26.9587 23.7669 25.653C23.9176 25.1939 24 24.6412 24 23.5C24 22.3588 23.9175 21.806 23.7669 21.347C23.3484 20.0413 22.3013 19.5 20.6157 19.5ZM22.1279 25.0531C21.9295 25.6881 21.3605 25.959 20.569 25.959H19.7788C19.7322 25.959 19.7083 25.9354 19.7083 25.8883V21.1118C19.7083 21.0646 19.7322 21.041 19.7788 21.041H20.569C21.3605 21.041 21.9295 21.3119 22.1279 21.947C22.2093 22.2179 22.2666 22.6884 22.2666 23.5C22.2666 24.3116 22.2092 24.7821 22.1279 25.0531ZM26.1047 19.5H30.3891C30.9217 19.5 31.2729 19.8147 31.2729 20.2464C31.2729 20.666 30.9218 20.9808 30.3891 20.9808H27.2596C27.2075 20.9808 27.1821 21.004 27.1821 21.0508V22.7186C27.1821 22.7654 27.2075 22.7888 27.2596 22.7888H29.7536C30.3116 22.7888 30.636 23.0914 30.636 23.5231C30.636 23.9548 30.3116 24.258 29.7536 24.258H27.2596C27.2075 24.258 27.1821 24.2814 27.1821 24.3276V26.59C27.1821 27.1385 26.7789 27.5 26.2343 27.5C25.6762 27.5 25.2729 27.1385 25.2729 26.59V20.2577C25.2729 19.8033 25.5854 19.5 26.1047 19.5Z"
          fill="#3B3C46"
        />
      </g>
      <defs>
        <clipPath id="clip0_1065_66257">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default function PdfIcon(
  props: Partial<CustomIconComponentProps> & {
    size?: 'large' | 'default' | 'small'
  }
) {
  const { size, ...rest } = { ...props }
  if (size === 'large') {
    return <Icon component={LargePdfSvg} {...rest} />
  }

  return <Icon component={PdfSvg} {...rest} />
}

PdfIcon.defaultProps = {
  size: 'default'
}
